import {DateTime} from 'luxon';
import {availabilitySubmission} from '../../shared/availability';

const uidOf=record=>record.userId||record.uid||record.userUid||record.createdByUid;
const nameOf=record=>String(record.username||record.userName||record.name||'').trim().toLowerCase();
export function overviewAttendanceStatus(value) {
  const status=String(value||'').trim().toLowerCase();
  return ['pending','accepted','declined'].includes(status)?status:null;
}

// Hover cards can retain an older event object while the team's live data updates.
export function overviewAttendanceEvent(event,team) {
  const id=event.eventId||event.id;
  const source=id&&Array.isArray(team?.events)?team.events.find(item=>(item.eventId||item.id)===id):null;
  if(!source)return event;
  const current=event.instanceDate?{...source,...source.overrides?.[event.instanceDate]}:source;
  return {...event,participants:current.participants,participantsUid:current.participantsUid,participantStates:current.participantStates};
}

// Merge touching/overlapping windows: two adjacent submissions cover one event.
export function overviewAvailabilityWarnings(event,people,state,timeZone='UTC') {
  if(!state?.ready||event.calendar==='personal')return {};
  const start=Date.parse(event.startUTC),end=Date.parse(event.endUTC);
  if(!Number.isFinite(start)||!Number.isFinite(end)||end<=start)return {};
  const zone=DateTime.now().setZone(timeZone).isValid?timeZone:'UTC';
  const weeks=[];
  for(let week=DateTime.fromMillis(start,{zone}).startOf('week');week.toMillis()<end;week=week.plus({weeks:1}))weeks.push(week);
  return Object.fromEntries(people.filter(person=>!['accepted','declined'].includes(overviewAttendanceStatus(person.status))).flatMap(person=>{
    const name=String(person.name||'').trim().toLowerCase();
    const rows=(state.records||[]).filter(record=>person.uid&&uidOf(record)?uidOf(record)===person.uid:nameOf(record)===name)
      .map(record=>({...record,userId:person.uid||name}));
    const windows=weeks.flatMap(week=>{
      const result=availabilitySubmission(rows,[],week.toISODate(),zone);
      return result.instances.map(record=>[Math.max(+result.week.start,Date.parse(record.startUTC)),Math.min(+result.week.end,Date.parse(record.endUTC))]);
    }).sort((a,b)=>a[0]-b[0]);
    let cursor=start;
    for(const [from,to] of windows){if(to<=cursor)continue;if(from>cursor)break;cursor=to;if(cursor>=end)break;}
    return cursor>=end?[]:[[person.uid||person.name,'Saved availability does not cover the full event.']];
  }));
}
